// Chakra Imports
import {
  Avatar,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  Select,
  Badge,
  VStack,
  Tooltip,
  Link,
} from '@chakra-ui/react';
// Custom Components
import { SidebarResponsive } from 'components/sidebar/Sidebar';
// Assets
import navImage from 'assets/img/layout/Navbar.png';
import { MdNotificationsNone, MdInfoOutline, MdAccessTime, MdPersonOff, MdOutlineSupportAgent } from 'react-icons/md';
import { FaEthereum } from 'react-icons/fa';
import Configurator from 'components/navbar/Configurator';
import routes from 'routes';
import { useAuth } from 'contexts/auth.context';
import { useNotificaciones } from 'contexts/notificaciones.context';
import { useResguardosBaja } from 'contexts/resguardosBaja.context';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function HeaderLinks(props: {
  secondary: boolean;
  [x: string]: any;
}) {
  const { secondary, theme, setTheme } = props;
  // Chakra Color Mode
  const navbarIcon = useColorModeValue('gray.400', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('#1E90FF', '#1E90FF');
  const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');
  const notifHoverBg = useColorModeValue('gray.50', 'navy.700');

  const { setUser } = useAuth();
  const navigate = useNavigate();
  const { notificaciones, descartar } = useNotificaciones();
  const { colaboradoresDeBaja, total: totalBajas } = useResguardosBaja();

  // Obtener hotel del usuario desde sessionStorage
  const userData = JSON.parse(sessionStorage.getItem('user') || '{}');
  // Convertir string de Hoteles en array
  const userHotels = userData.Hoteles ? userData.Hoteles.split(',') : [];
  const [selectedHotel, setSelectedHotel] = useState(userHotels[0] || '');

  // Mapeo de códigos de hotel a nombres
  const hotelMap: Record<string, string> = {
    GVRN: 'Grand Velas Riviera Nayarit',
    GVLC: 'Grand Velas Los Cabos',
    GVRM: 'Grand Velas Riviera Maya',
    VV: 'Velas Vallarta',
    CV: 'Casa Velas',
    MDC: 'Mar del Cabo',
    GVBLC: 'Grand Velas Boutique Los Cabos',
    CC: 'Contact Center',
    DEMO: 'Hotel Demo',
  };

  const handleLogout = () => {
    setUser(null);
    navigate('/auth/sign-in/default');
    //borramos la session storage
    sessionStorage.clear();
  };

  const handleHotelChange = (hotel: string) => {
    setSelectedHotel(hotel);
    sessionStorage.setItem('hotelSeleccionado', hotel);

    const eventoCambioHotel = new CustomEvent('hotelCambiado', { detail: { hotel } });
    window.dispatchEvent(eventoCambioHotel);
  };

  useEffect(() => {
    const hotelGuardado = sessionStorage.getItem('hotelSeleccionado');
    if (hotelGuardado && hotelMap[hotelGuardado]) {
      setSelectedHotel(hotelGuardado);
    } else if (userHotels.length > 0) {
      setSelectedHotel(userHotels[0]);
      sessionStorage.setItem('hotelSeleccionado', userHotels[0]);
    }
  }, [userHotels]);
  const data = JSON.parse(sessionStorage.getItem('user') || '{}');
  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="999px"
      boxShadow={shadow}
    >

      {userData.RolId === 3 &&
        <Badge
          colorScheme='green'
          borderRadius="20px"
          fontSize="12px"
          p="10px"
          me="10px"
        >
          Estandar
        </Badge>
      }
      {userData.RolId === 2 &&
        <Badge
          colorScheme='blue'
          borderRadius="20px"
          fontSize="12px"
          p="10px"
          me="10px"
        >
          Gerente
        </Badge>
      }
      {/* Select de Hotel */}
      <Select
        w="200px"
        me="10px"
        borderRadius="20px"
        fontSize="sm"
        bg={useColorModeValue('gray.100', 'navy.900')}
        color={useColorModeValue('gray.700', 'white')}
        value={selectedHotel}
        onChange={(e) => handleHotelChange(e.target.value)}

      >
        {userHotels.map((codigo: string) => (
          <option key={codigo} value={codigo}>
            {hotelMap[codigo] || codigo}
          </option>
        ))}

      </Select>




      {/* Resto del código permanece igual */}
      {/* <SearchBar
        mb={() => {
          if (secondary) {
            return { base: '10px', md: 'unset' };
          }
          return 'unset';
        }}
        me="10px"
        borderRadius="20px"
      /> */}

      <Flex
        bg={ethBg}
        display={secondary ? 'flex' : 'none'}
        borderRadius="20px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Flex
          align="center"
          justify="center"
          bg={ethBox}
          h="29px"
          w="29px"
          borderRadius="20px"
          me="7px"
        >
          <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
        </Flex>
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          1,924
          <Text as="span" display={{ base: 'none', md: 'unset' }}>
            {' '}
            ETH
          </Text>
        </Text>
      </Flex>
      <SidebarResponsive routes={routes} />
      <Tooltip label="Reportar un problema" placement="bottom" hasArrow>
        <Link
          href="https://restapi.velasresorts.com/report-issue?project=inventarios"
          isExternal
          _hover={{ textDecoration: 'none' }}
        >
          <Box
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
            mr="10px"
            cursor="pointer"
          >
            <Icon
              as={MdOutlineSupportAgent}
              w="20px"
              h="20px"
              color={navbarIcon}
            />
          </Box>
        </Link>
      </Tooltip>
      <Menu>
        <MenuButton p="0px">
          <Box position="relative" display="inline-flex" mr="10px"
            sx={(notificaciones.length + totalBajas) > 0 ? {
              '@keyframes bellRing': {
                '0%, 100%': { transform: 'rotate(0deg)' },
                '10%, 30%': { transform: 'rotate(-12deg)' },
                '20%, 40%': { transform: 'rotate(12deg)' },
                '50%': { transform: 'rotate(0deg)' },
              },
              animation: 'bellRing 2s ease-in-out infinite',
            } : {}}
          >
            <Icon
              mt="6px" as={MdNotificationsNone} w="20px" h="20px"
              color={(notificaciones.length + totalBajas) > 0 ? 'orange.400' : navbarIcon}
              transition="color 0.3s"
            />
            {(notificaciones.length + totalBajas) > 0 && (
              <Badge
                position="absolute"
                top="-2px"
                right="-4px"
                colorScheme="red"
                borderRadius="full"
                fontSize="9px"
                minW="16px"
                h="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                p="0"
                sx={{
                  '@keyframes badgePulse': {
                    '0%, 100%': { transform: 'scale(1)', opacity: 1 },
                    '50%': { transform: 'scale(1.25)', opacity: 0.85 },
                  },
                  animation: 'badgePulse 1.4s ease-in-out infinite',
                }}
              >
                {notificaciones.length + totalBajas}
              </Badge>
            )}
          </Box>
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: '30px', md: 'unset' }}
          minW={{ base: 'unset', md: '400px', xl: '450px' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          {/* Header */}
          <Flex w="100%" mb="20px" align="center">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              Notificaciones
            </Text>
            {notificaciones.length > 0 && (
              <Text
                fontSize="sm"
                fontWeight="500"
                color={textColorBrand}
                ms="auto"
                cursor="pointer"
                onClick={() => notificaciones.forEach(n => descartar(n.id))}
              >
                Marcar todas como leídas
              </Text>
            )}
          </Flex>

          {/* Items */}
          <Flex flexDirection="column" maxH="360px" overflowY="auto">
            {(notificaciones.length + totalBajas) === 0 ? (
              <VStack py={6} spacing={2} opacity={0.5}>
                <Icon as={MdNotificationsNone} w="28px" h="28px" color="gray.400" />
                <Text fontSize="sm" color="gray.400">Sin notificaciones pendientes</Text>
              </VStack>
            ) : (
              <>
                {notificaciones.map((n, idx) => (
                  <Box key={`prestamo-${n.id}`}>
                    <Box
                      cursor="pointer"
                      px={3}
                      py={3}
                      borderRadius="8px"
                      _hover={{ bg: notifHoverBg }}
                      onClick={() => {
                        navigate('/admin/main/ver/salidas', {
                          state: {
                            fromNotificacion: {
                              id: n.id,
                              solicitanteNombre: n.solicitanteNombre,
                              cantidad: n.cantidad,
                            },
                          },
                        });
                        descartar(n.id);
                      }}
                    >
                      <HStack align="start" spacing={3}>
                        <Icon as={MdAccessTime} color="orange.400" w="18px" h="18px" mt="2px" flexShrink={0} />
                        <Box flex={1}>
                          <Text fontSize="sm" fontWeight="700" color={textColor}>
                            &ldquo;{n.solicitanteNombre} solicita {n.cantidad} equipo(s) en préstamo&rdquo;
                          </Text>
                          <Text fontSize="xs" color="gray.400" mt="2px">
                            {new Date(n.fecha + 'T00:00:00').toLocaleDateString('es-MX', {
                              day: '2-digit', month: 'short', year: 'numeric',
                            })}
                          </Text>
                        </Box>
                        <Button
                          size="xs"
                          variant="ghost"
                          colorScheme="gray"
                          onClick={(e) => { e.stopPropagation(); descartar(n.id); }}
                          aria-label="Descartar"
                          minW="auto"
                          px={1}
                        >
                          ✕
                        </Button>
                      </HStack>
                    </Box>
                    {(idx < notificaciones.length - 1 || totalBajas > 0) && <Divider my={1} />}
                  </Box>
                ))}
                {colaboradoresDeBaja.map((c, idx) => (
                  <Box key={`baja-${c.ResguardoId}`}>
                    <Box
                      cursor="pointer"
                      px={3}
                      py={3}
                      borderRadius="8px"
                      _hover={{ bg: notifHoverBg }}
                      onClick={() => {
                        navigate('/admin/main/ecommerce/referrals', {
                          state: { searchUsuarioNumColab: c.usuarioNumColab },
                        });
                      }}
                    >
                      <HStack align="start" spacing={3}>
                        <Icon as={MdPersonOff} color="red.400" w="18px" h="18px" mt="2px" flexShrink={0} />
                        <Box flex={1}>
                          <Text fontSize="sm" fontWeight="700" color={textColor}>
                            {c.NombreNomina || c.usuarioDueno} fue dado de baja y aún conserva un resguardo (#{c.ResguardoId})
                          </Text>
                          <Text fontSize="xs" color="gray.400" mt="2px">
                            {c.Departamento} · Estatus resguardo: {c.resguardoStatus}
                          </Text>
                          <Text fontSize="xs" color={textColorBrand} fontWeight="500" mt="4px">
                            Ver más detalles
                          </Text>
                        </Box>
                      </HStack>
                    </Box>
                    {idx < colaboradoresDeBaja.length - 1 && <Divider my={1} />}
                  </Box>
                ))}
              </>
            )}
          </Flex>
        </MenuList>
      </Menu>

      {/* Sección de Información en Navbar */}
     {/*  <Menu>
        <MenuButton p="0px">
          <Icon
            mt="6px"
            as={MdInfoOutline}
            color={navbarIcon}
            w="18px"
            h="18px"
            me="10px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="20px"
          me={{ base: '30px', md: 'unset' }}
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          minW={{ base: 'unset' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Image src={navImage} borderRadius="16px" mb="28px" />
          <Flex flexDirection="column">
            <Link w="100%" href="#">
              <Button w="100%" h="44px" mb="10px" variant="brand">
                Ver mis Resguardos
              </Button>
            </Link>
            <Link
              w="100%"
              href="#"
            >
              <Button
                w="100%"
                h="44px"
                mb="10px"
                border="1px solid"
                bg="transparent"
                borderColor={borderButton}
              >
                Ver mi Perfil
              </Button>
            </Link>
            <Link
              w="100%"
              href="https://www.velasresorts.com/"
            >
              <Button
                w="100%"
                h="44px"
                variant="no-hover"
                color={textColor}
                bg="transparent"
              >
                Visitar Velas Resorts
              </Button>
            </Link>
          </Flex>
        </MenuList>
      </Menu> */}
      <Configurator
        mini={props.mini}
        setMini={props.setMini}
        theme={theme}
        setTheme={setTheme}
      />

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color={textColor}
            name={data.FullName || 'Usuario'}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              ps="20px"
              pt="16px"
              pb="10px"
              w="100%"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
            >

              👋&nbsp; Hey, {data.FullName}!
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              borderRadius="8px"
              px="14px"
            >
              <Text fontSize="sm">Configuración de Perfil</Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              borderRadius="8px"
              px="14px"
            >
              {/* <Text fontSize="sm">Configuración de Newsletter</Text> */}
            </MenuItem>
            <MenuItem
              _hover={{ bg: 'none' }}
              _focus={{ bg: 'none' }}
              color="red.400"
              borderRadius="8px"
              px="14px"
              onClick={handleLogout}
            >
              <Text fontSize="sm">Cerrar Sesión</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>

    </Flex>
  );
}